import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validate environment variables
if (!supabaseUrl) {
  throw new Error('supabaseUrl is required. Please check your environment variables.');
}

if (!supabaseAnonKey) {
  throw new Error('supabaseAnonKey is required. Please check your environment variables.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
